var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLog)?_c('div',{staticClass:"comp-log comp"},[_c('div',{staticClass:"debugger",on:{"click":_vm.toggleLogPanel}},[_c('i',{staticClass:"fa fa-laptop"})]),(_vm.showLogPanel)?_c('logPanel'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }